import { SummaryOnHandType } from "../infrastructure/enums/summary-on-hand-type.enum";
import { AdAutomationEnableOption, AdAutomationPauseOption } from "../infrastructure/enums/meta-data-field.enum";
import { BetaFeatureAcceptanceStatus } from "../infrastructure/enums/beta-feature-acceptance.enum";
import { IAmazonAdsConfig } from "./amazon-ads-config";
import { SalesVelocitySettingData } from "./sales-velocity";

export class Company {
  companyType: string;
  companyKey?: string;
  companyName: string;
  forecastKey?: string;
  forecastName?: string;
  moq?: number;
  additionalInventory?: number;
  leadTime?: number;
  orderInterval?: number;
  operation?: string;
  serviceLevel?: number;
  email?: string;
  lastCalculatedLostSaleDate?: Date;
  isLostSalesSettingsChange?: boolean;
  lastForecastDate?: Date;
  lastSyncDate?: Date;
  sellerId?: string;
  marketplaceId?: string;
  mwsAuthToken?: string;
  ratings?: any[];
  spikePercent?: number;
  plungePercent?: number;
  isManualInventory?: boolean;
  requestsOnboarding?: boolean;
  customerId?: string;
  subscriptionId?: string;
  subscriptionStatus?: string;
  purchaseItems?: number;
  purchasePrice?: number;
  purchasePriceWithMoq?: number;
  purchaseUniques?: number;
  pastDuePoLines?: number;
  expediteItemLines?: number;
  jobInitiator?: string;
  jobProcessing?: string;
  qbfsSyncStatus?: any;
  isNotifyingAfterSync?: boolean;
  isNotifyingAfterForecast?: boolean;
  lostSaleTracking?: any;
  isLocked?: boolean;
  isPromptedOnLogin?: boolean;
  disabledFeatures?: any;
  phone?: string;
  fax?: string;
  website?: string;
  addressShippingUuid?: string;
  addressBillingUuid?: string;
  criticalErrorCode?: string;
  companyPreferences?: CompanyPreferences;
  accessToken?: string;
  refreshToken?: string;
  createdAt?: Date;
  updatedAt?: Date;
  initialSyncDate?: string;
  inventorySourcePreference?: string;
  isAuthorized?: boolean;
  restockModel?: string;
  localLeadTime?: number;
  targetQtyOnHandMin?: number;
  targetQtyOnHandMax?: number;
  salesVelocityType?: string;
  salesVelocitySettingData?: SalesVelocitySettingData;
  shipmentLastRefresh?: Date;
  purchasingSalesVelocityType?: string;
  purchasingSalesVelocitySettingData?: SalesVelocitySettingData;
  displayRestockAMZ?: boolean;
  displayAdvertisingAMZ?: boolean;
  displayItemsRepricingAMZ?: boolean;
  shipStationBundleMode?: 'kit' | 'case_pack';
  featureOnboardingState?: {
    advertisingAMZ?: boolean;
    itemsRepricingAMZ?: boolean;
  };
  betaFeatureDisclamerAcceptance?: {
    advertisingAMZ?: BetaFeatureAcceptanceStatus | null;
    itemsRepricingAMZ?: BetaFeatureAcceptanceStatus | null;
  };
  pendingOrderToggle?: boolean;
  pendingOrderLimitDay?: number;
  summaryCounts?: Record<string, number>;
  uploadedColumns?: string[];
  isUsingAdjustedDailySalesRate?: boolean;
  isUsingInboundWorking?: boolean;
  willRemindToRunForecast?: boolean;
  isAdjustingDailySalesRateForOutOfStock?: boolean;
  isUsingInboundShipped?: boolean;
  isUsingInboundReceiving?: boolean;
  isUsingFcTransfer?: boolean;
  isUsingWarehouseInventory?: boolean;
  isUsingOnOrder?: boolean;
  isUsingOnHandFbm?: boolean;
  latestTotalOrder?: number;
  last3Months?: string[];
  ignoreShipmentDays?: number;
  isUnlockedFirstTime?: boolean;
  skipOnboardingComment?: string;
  isSkipOnboarding?: boolean;
  willDisableMultipleWarehouses?: boolean;
  currencyCode?: string;
  isModifyForecastUsingUnit?: boolean;
  autoHideMaxOrderQty?: number;
  summaryOnHandType?: SummaryOnHandType;
  isUsingAWDInventoryQty?: boolean;
  ignoreOldPOsDays?: number;
  willSyncQuickbooksAll?: boolean;
  shouldIncludeAllOpenPOs?: boolean;
  vendorLastUploadDate?: Date;
  demandLastUploadDate?: Date;
  supplyLastUploadDate?: Date;
  itemLastUploadDate?: Date;
  bomLastUploadDate?: Date;
  historyOverrideLastUploadDate?: Date;
  forecastedHistorySettingLastUploadDate?: Date;
  demandSourcePreference?: string;
  shouldHidePOKitRecommendation?: boolean;
  logoUrl?: string;
  willRemindToRunSync?: boolean;
  isAdAutomationEnabled?: boolean;
  adAutomationPauseStatus?: AdAutomationPauseOption;
  adAutomationEnableStatus?: AdAutomationEnableOption;
  companyLogo?: string;
  paymentLogo?: string;
  // isSendSFTPWithEmail?: boolean;
  captchaToken?: string | null;
  minDaysUntilStockOutRisk?: number;
  maxDaysUntilStockOutRisk?: number;
  amazonAds?: IAmazonAdsConfig
  lastCampaignsSyncedAt?: Date;
  hasCreatedMinMaxCustomReport?: boolean;

  constructor(init?: Partial<Company>) {
    if (init) {
      //if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}

export class CompanyPreferences {
  config: {
    company: {
      skipped: boolean;
      completed: boolean;
    };
    shipment?:{
      skipped: boolean;
      completed: boolean;
    }
    vendor: {
      skipped: boolean;
      completed: boolean;
      uploaded: boolean;
    };
    item: {
      skipped: boolean;
      completed: boolean;
      uploaded: boolean;
    };
    bom?: {
      skipped: boolean;
      completed: boolean;
      uploaded: boolean;
    };
    supply?: {
      skipped: boolean;
      completed: boolean;
      uploaded: boolean;
    };
    demand?: {
      skipped: boolean;
      completed: boolean;
      uploaded: boolean;
    };
    forecast: {};
    hasScheduled?: boolean;
  };
}
